import { css } from '@flipster/styled-system/css';

import SparkLaunchpoolInfo from './SparkLaunchpoolInfo';
import SparkLaunchpoolItemHeader from './SparkLaunchpoolItemHeader';
import SparkTotalReward from './SparkTotalReward';
import { HowToRedeem } from './how-to-redeem';
import { Hr } from './misc';

const SparkLaunchpoolItem = () => {
  return (
    <section className={css({ mt: { base: 32, tablet: 40 } })}>
      <SparkLaunchpoolItemHeader />
      <HowToRedeem />
      <div className={css({ pt: 12, pb: 16, px: 16, bgColor: 'background.default.level-1', rounded: 8 })}>
        <SparkLaunchpoolInfo />
        <Hr />
        <SparkTotalReward />
      </div>
    </section>
  );
};

export default SparkLaunchpoolItem;
